import { useTheme, useMediaQuery } from '@mui/material';
import { breakpoints as DEFAULT_BREAKPOINTS } from '../tokens';

interface UseAIDTMediaQueryOptions {
  breakpoints?: typeof DEFAULT_BREAKPOINTS;
}

const useAIDTMediaQuery = (options: UseAIDTMediaQueryOptions = {}) => {
  const { breakpoints = DEFAULT_BREAKPOINTS } = options;
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down(breakpoints.xs)); // 390px 이하
  const isMiniTablet = useMediaQuery(theme.breakpoints.down(breakpoints.sm)); // 512px 이하
  const isTablet = useMediaQuery(theme.breakpoints.down(breakpoints.md)); // 830px 이하
  const isNotebook = useMediaQuery(theme.breakpoints.down(breakpoints.lg)); // 1024px 이하
  const isDesktop = useMediaQuery(theme.breakpoints.up(breakpoints.lg + 1)); // 1025px 이상

  const isHeightSmall = useMediaQuery(`(max-height: ${breakpoints.height}px)`);

  return {
    isMobile,
    isMiniTablet,
    isTablet,
    isNotebook,
    isDesktop,
    isHeightSmall,
  };
};

export default useAIDTMediaQuery;
